import { FC } from 'react';
import { SliderImage, SliderVideo } from '@/components/common/Gallery/styles';
import { GalleryItemProps } from '@/components/common/Gallery/types';

export const GalleryItem: FC<GalleryItemProps> = ({
  item,
  index,
  onPointerUp = () => {},
  inFullScreen,
  isNotesGallery,
}) => {
  if (
    item.endsWith('.jpg') ||
    item.endsWith('.png') ||
    item.endsWith('.gif') ||
    item.endsWith('.webp')
  ) {
    return (
      <div
        style={{
          width: '100%',
          height: '100%',
          position: 'relative',
          background: isNotesGallery && !inFullScreen ? '#D0D5DD' : 'transparent',
          borderRadius: isNotesGallery ? '8px' : 0,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <SliderImage
          src={item}
          onPointerUp={onPointerUp}
          inFullScreen={inFullScreen}
          isNotesGallery={isNotesGallery}
        />
      </div>
    );
  }

  if (item.endsWith('.mp4') || item.endsWith('.webm') || item.endsWith('.ogg')) {
    return (
      <div
        style={{
          width: '100%',
          height: '100%',
          position: 'relative',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <SliderVideo
          controls
          style={{
            width: '100%',
            height: '100%',
            objectFit: 'contain',
            aspectRatio: '1920/1080',
          }}
        >
          <source src={item} type={`video/${item.split('.').pop()}`} />
          Your browser does not support the video tag.
        </SliderVideo>
      </div>
    );
  }

  if (item.includes('youtube.com') || item.includes('vimeo.com')) {
    return (
      <iframe
        src={item}
        frameBorder="0"
        allow="autoplay; encrypted-media"
        allowFullScreen
        title={`iframe-${index}`}
        style={{
          width: '100%',
          height: '100%',
          aspectRatio: '1920/1080',
        }}
      />
    );
  }

  //if pdf use google viewer
  if (item.endsWith('.pdf')) {
    return (
      <iframe
        src={`https://docs.google.com/viewer?url=${encodeURIComponent(item)}&embedded=true&preview=true`}
        frameBorder="0"
        allow="autoplay; encrypted-media"
        allowFullScreen
        title={`iframe-${index}`}
        style={{ width: '100%', height: '100%' }}
      />
    );
  }

  return (
    <div
      style={{
        width: '100%',
        height: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: 'gray',
      }}
    >
      <p>Unsupported content type</p>
    </div>
  );
};
